import { Button } from "react-bootstrap";
import "./CalcListElement.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useEffect, useState } from "react";

export interface CalcListElementProps {
  order: number;
  amount: number;
  label: string;
}

interface CalcsProps {
  name: string;
  label: string;
  onChange: (data: CalcListElementProps[]) => void;
  defaultValue: CalcListElementProps[];
}

const EMPTY_CALC_LIST_ELEMENT: CalcListElementProps = {
  order: 0,
  amount: 0,
  label: "",
};

export const CalcListElement = ({
  defaultValue,
  name,
  label,
  onChange,
}: CalcsProps) => {
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const { control, watch } = useForm({
    mode: "all",
    defaultValues: {
      data: defaultValue,
    },
  });

  const { fields, append, remove } = useFieldArray<CalcListElementProps>({
    control,
    name: "data",
  });

  const watchedData = watch("data");

  useEffect(() => {
    const reorderedData = watchedData.map((item, index) => ({
      ...item,
      order: index,
    }));

    onChange(reorderedData);
  }, [watchedData, onChange]);

  return (
    <div className="calcListElement_root">
      <p>{label}</p>
      <div className="row">
        {fields &&
          fields
            .sort((a, b) => a.order - b.order)
            .map((f, index) => {
              return (
                <div key={f.id} className="col-12 col-md-6 mt-3">
                  <Controller
                    name={`data.${index}.order`}
                    control={control}
                    defaultValue={f.order}
                    render={({ value }) => (
                      <input type="hidden" value={value} />
                    )}
                  />
                  <div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                    <div className="flex-grow-1 me-2">
                      <Controller
                        name={`data.${index}.label`}
                        control={control}
                        defaultValue={f.label}
                        render={({ onChange, value }) =>
                          editingIndex === index ? (
                            <input
                              type="text"
                              value={value ?? ""}
                              onChange={onChange}
                              className="form-control"
                              autoFocus
                            />
                          ) : (
                            <span>{value || "—"}</span>
                          )
                        }
                      />
                    </div>

                    <div className="d-flex flex-shrink-0 gap-1">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() =>
                          setEditingIndex(editingIndex === index ? null : index)
                        }
                      >
                        {editingIndex === index ? "Fine" : "Modifica"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        onClick={() => remove(index)}
                        disabled={editingIndex === index}
                      >
                        Rimuovi
                      </button>
                    </div>
                  </div>

                  <Controller
                    name={`data.${index}.amount`}
                    control={control}
                    defaultValue={f.amount}
                    render={({ onChange, value }) => (
                      <div className="input-group">
                        <span className="input-group-text">&euro;</span>
                        <input
                          className="form-control"
                          type="number"
                          step="0.1"
                          value={value ?? ""}
                          onChange={onChange}
                          placeholder="Importo"
                        />
                      </div>
                    )}
                  />
                </div>
              );
            })}
      </div>
      <Button
        onClick={() => {
          append({
            ...EMPTY_CALC_LIST_ELEMENT,
            order:
              fields.length > 0
                ? Math.max(...fields.map((f) => f.order ?? 0)) + 1
                : 0,
          });
        }}
        className="calcListElement_addButton mt-3"
      >
        <FontAwesomeIcon icon={faPlus} />
      </Button>
    </div>
  );
};
